module.exports = __webpack_public_path__ + "b078bce45ec394a291efb83470319857.pdf";